import React from 'react';
import { Target } from 'lucide-react';
import { styles } from '../../styles/globalStyles';

const Header = () => {
  return (
    <header style={styles.header}>
      <div style={styles.headerContent}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>
            <Target size={16} color="#ffffff" />
          </div>
          Agent Development Platform
        </div>
        <nav style={styles.nav}>
          <a href="#platform" style={styles.navLink}>Platform</a>
          <a href="#dashboard" style={styles.navLink}>Dashboard</a>
          <a href="#agents" style={styles.navLink}>Agent Library</a>
          <a href="#use-cases" style={styles.navLink}>Use Cases</a>
          <a href="#build-agents" style={styles.navLink}>Build Agents</a>
          <a href="#docs" style={styles.navLink}>Documentation</a>
          <button style={styles.navButton}>Get Started</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;